import { FC, ReactNode } from "react";
// Icons
import { Check, ChevronDown } from 'lucide-react';

type Props = {
  stepNumber: number;
  title: string;
  tag?: string;
  isActive: boolean;
  isCompleted: boolean;
  summary?: ReactNode;
  onHeaderClick: () => void;
  children: ReactNode;
}

const AccordionStep:FC<Props> = ({ stepNumber, title, tag, isActive, isCompleted, summary, onHeaderClick, children }) => (
  <section className={`border rounded-xl overflow-hidden transition-colors ${isActive ? 'border-orange-500/50' : 'border-gray-700'}`}>
    <button
      type="button"
      onClick={onHeaderClick}
      className="w-full flex items-center gap-3 p-5 text-left hover:bg-[#2a2a2e]/40 transition-colors"
    >
      <div
        className={`flex items-center justify-center w-8 h-8 rounded-full font-bold text-sm shrink-0
          ${isCompleted
            ? 'bg-orange-600 text-white'
            : isActive
              ? 'bg-orange-500/20 text-orange-500'
              : 'bg-gray-700/50 text-gray-400'
          }
        `}
      >
        {isCompleted ? <Check className="w-4 h-4" /> : stepNumber}
      </div>
      <h2 className="text-lg font-medium text-gray-100 whitespace-nowrap shrink-0">{title}</h2>
      {tag && <span className="text-xs uppercase tracking-wider text-gray-500 whitespace-nowrap shrink-0">{tag}</span>}
      <div className="flex-1 min-w-0 flex justify-end overflow-hidden">
        {!isActive && summary}
      </div>
      <ChevronDown className={`w-5 h-5 text-gray-400 shrink-0 transition-transform ${isActive ? 'rotate-180' : ''}`} />
    </button>
    {isActive && (
      <div className="px-5 pb-6">
        {children}
      </div>
    )}
  </section>
);

export default AccordionStep;
